import { useEffect, useState } from "react";
import { SiteHeader } from "../../components/header/header";
import classNames from "classnames";

import { carsData } from "../../mock-data/car-data";
import { ItemCard } from "../../components/cards/item-card";
import { OurQualities } from "../../components/containers/qualities";
import { SiteFooter } from "../../components/footer/footer";
import { UseCarContext } from "../../services/products/product.context";
import { UseCartList } from "../../services/cart/cart.context";
import { CartComponent } from "../saved/cart";
import { CarsFilter } from "../../components/utilities/filter-component";
import { searchProduct } from "../../_helpers/search";

export const HomePage = () => {

    const { someCars } = UseCarContext();
    const { saveToWishList, wishList, toggleCart, openCart } = UseCartList();
    const [cartItem, setCartItem] = useState();
    const [searchFor, setSearchFor] = useState('All');
    const [pageCars, setPageCars] = useState(someCars);
   
    const handleFilter = (v) => {
       const resultsArray = searchProduct(v, someCars);
       setPageCars(resultsArray);
    }

    useEffect(() => {
        setPageCars(someCars);
    }, [someCars])

    return (
        <div className="f-pg app-pg">
            <SiteHeader />
            <CartComponent 
                inView={openCart} 
                itemdata={cartItem}
                resetCart={() => setCartItem()} 
            />
            <div className="home-theme">
               <div className="blk-cover flx-cnt">
                  <div className="cover-lg-txt">Affordable used cars</div>
                  <div className="cover-mid-txt">
                    Get used cars in perfect conditions from China, at very affordable costs within 65 days of ordering.
                  </div>
                  <div className="flx-cnt">
                    <button className="order-bttn" onClick={() => window.location.href = "/catalog"}>
                        Order your dream car
                    </button>
                  </div>
               </div>
            </div>
            <div className="lg-txt hd">Bestsellers</div>
            <div className="flx-rw filters">
                <CarsFilter setFilter={(v) => {
                    setSearchFor(v);
                    handleFilter(v);
                }} />
                <div className="filter-label">
                    {searchFor} Cars
                </div>
            </div>
            
            <div className="car-list">
                {pageCars?.map((car) => (
                    <ItemCard 
                        item={car}
                        openCart={() => {
                            toggleCart();
                            setCartItem(car);
                        }}
                        wishList={wishList}
                        addToList={() => saveToWishList(car)}
                    />
                ))}
            </div>
            <OurQualities />
            <SiteFooter />
        </div>
    )
}